import { kea } from 'kea'
import PropTypes from 'prop-types'
import { put } from 'redux-saga/effects'
import delay from 'lib/utils/delay'

import controller from './controller.rb'

import railsContext from 'lib/selectors/rails-context'

export default kea({
  path: () => ['scenes', 'edm', 'index'],

  connect: {
    props: [railsContext, ['eventDialog as dialog']]
  },

  actions: () => ({
    test: true,
    closeModal: true,
    removeDialog: eventDialogId => ({ eventDialogId }),
    redirectTo: true,
    startInforming: eventDialog => ({ eventDialog }),
    activeModal: true,
    initEventDialog: true,
    setEventDialog: eventDialog => ({ eventDialog })
  }),

  reducers: ({ path, actions }) => ({
    eventDialog: [
      null,
      PropTypes.object,
      {
        [actions.setEventDialog]: (state, payload) => payload.eventDialog,
        [actions.activeModal]: state => {
          return {
            ...state,
            isModalOpen: true
          }
        },
        [actions.closeModal]: (state, payload) => {
          return {
            ...state,
            isModalOpen: false,
            dismissed: true
          }
        }
      }
    ]
  }),

  selectors: ({ selectors }) => ({
    editedEventDialog: [
      () => [selectors.dialog, selectors.eventDialog],
      (dialog, eventDialog) => {
        return {}
      }
    ]
  }),

  takeLatest: ({ actions, workers }) => ({
    [actions.startInforming]: function * (action) {
      const { activeModal } = this.actions
      const { eventDialog } = action.payload
      yield delay(eventDialog.news ? 2000 : 0)
      yield put(activeModal())
    },
    [actions.initEventDialog]: function * (action, payload) {
      const { setEventDialog, startInforming } = this.actions
      const dialog = yield this.get('dialog')
      const toBeDisplayed =
        dialog != null &&
        !(dialog && Object.keys(dialog).length === 0 && dialog.constructor === Object) &&
        dialog.eventDialogId != null
      if (toBeDisplayed) {
        yield put(setEventDialog(dialog))
        yield put(startInforming(dialog))
      }
    },
    [actions.removeDialog]: function * (action) {
      const { closeModal } = this.actions
      yield put(closeModal())

      const { eventDialogId } = action.payload
      const response = yield controller.create({
        event_dialog_id: eventDialogId
      })
      if (response.error || !response) {
        throw new Error(response.error)
      }
    }
  })
})
